import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { theme, resolvedTheme, toggleTheme } = useTheme();

  const getIcon = () => {
    return resolvedTheme === 'dark' ? '🌙' : '☀️';
  };

  const getTitle = () => {
    return resolvedTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';
  };

  return (
    <button
      onClick={toggleTheme}
      className="min-h-[40px] rounded-full border border-white/10 bg-white/[0.03] px-3 py-2 text-primary-container transition-colors duration-200 hover:bg-primary-container/10"
      title={getTitle()}
      aria-label={`Current theme: ${resolvedTheme}. ${getTitle()}`}
    >
      <span className="text-base">{getIcon()}</span>
      {theme === 'system' && (
        <span className="ml-1 font-code text-[10px] uppercase tracking-[0.14em] text-on-surface-variant">auto</span>
      )}
    </button>
  );
};

export default ThemeToggle;